module.exports = {
      id: "authorwhite-usage",
      viewBox: "0 0 30.127 24.506",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#authorwhite",
      toString: function () {
        return this.url;
      }
    }